import { TanqueGeneral } from './TanqueGeneral';

export class GrupoDeTanques extends TanqueGeneral{
    tanques: TanqueGeneral[];
}